import PageHeader from '../components/PageHeader';
import PageLayout from '../layouts/PageLayout';
import { useNavigate, useParams } from 'react-router-dom';
import RequestTableWithQueryParams from '../components/RequestTableWithQueryParams';

const RequestsFiltered = () => {

  const navigate = useNavigate();
  const { year, month } = useParams();

  const onNavigateBack = () => {
    navigate(-1);
  };

  return (
    <PageLayout>
      <div className="flex gap-4 items-center">
        <PageHeader
          title={`Cereri necompletate - ${year}/${month}`}
          onBackButtonPress={onNavigateBack}
          buttonId="client__return-button"
        />
      </div>
      <RequestTableWithQueryParams year={year} month={month} />
    </PageLayout>
  );
}

export default RequestsFiltered;